<template>
    <div class="">          
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="gradation-title-wrapper mb-2">
                    <vs-button color="primary" type="border" radius icon-pack="feather" icon="icon-arrow-left" class="mb-2 mt-4 text-primary" @click="back"></vs-button>
                    <div class="gradation-title-wrap mt-6">
                        <h1 class="heading">View <span class="text-color-primary">Vacant Property</span></h1>
                    </div>
                </div>
            </div>
        </div>
        <vx-card title="" class="mt-4" no-shadow card-border>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Property Address</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="property.address.address1"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Property Type</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="property.portion_type"></span>
                        </div>
                    </div>
                </div>
            </div>            
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Bed Rooms</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="property.property_type"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Bath Rooms</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="property.bath_rooms"></span>
                        </div>
                    </div>
                </div>   
            </div>             
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Security Deposit</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="property.security_deposit"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Monthly Rent</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="property.monthly_rent"></span>
                        </div>
                    </div>
                </div>
            </div>              
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Status</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="property.status"></span>
                        </div>
                    </div>
                </div>
            </div>      
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full" v-bind:key="index" v-for="(eligibility, index) in property.eligibilities">
                    <div class="flex justify-content-between">
                        <div class="left w-full">
                            <div class="vx-row mb-4">
                                <div class="vx-col w-full">
                                    <span>Eligibility Criteria</span>
                                </div>
                                <div class="vx-col w-full">
                                    <span class="block vs-input--view" v-text="eligibility.eligibility_criteria"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full" v-bind:key="index" v-for="(special, index) in property.specials">
                    <div class="flex justify-content-between">
                        <div class="left w-full">
                            <div class="vx-row mb-4">
                                <div class="vx-col w-full">
                                    <span>Specials</span>
                                </div>
                                <div class="vx-col w-full">
                                    <span class="block vs-input--view" v-text="special.special"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="vx-row">  
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Photos</span>
                        </div>
                        <div class="vx-col w-full">
                            <div class="demo-alignment">
                                <vs-chip transparent color="primary" class="mt-1" @click="removeFile(option, index)" v-bind:value="option.id" v-bind:key="option.id" v-for="(option, index) in property.documents">
                                    <a :title="option.file_name" target="PmsAttachement" v-bind:href="option.document_location" type="button" >
                                        {{option.file_name}}
                                    </a>
                                </vs-chip>
                            </div>   
                        </div>
                    </div>                 
                </div>
            </div>            
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Description</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view vs-textarea--view" v-html="property.description"></span>
                        </div>
                    </div>
                </div>
            </div>    
            
        </vx-card>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import Datepicker from 'vuejs-datepicker'
import router from './../../../router.js'
import VacantProperty from '@/js/vacantProperty.js'
import vSelect from 'vue-select'
import currency from 'v-currency-field'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: 'addProperty',
  data () {
    return {
      property: {},
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  components: {
    Datepicker,
    'v-select': vSelect,
    quillEditor,
    currency,
    VueGoogleAutocomplete
  },
  created () {
    VacantProperty.getVacantPropertyById(this, this.$route.params.id)
  },
  mounted () {
  },
  methods: {
    setVacantProperty (property) {
      this.property = property
    },
    back () {
      router.go(-1)
    }
  }
}
</script>